import Icon from '../components/Icon.vue'

Icon.register({
  'arrow-circle-down': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504 256c0 137-111 248-248 248s-248-111-248-248 111-248 248-248 248 111 248 248zM360.4 227.1l-72.4 75.5v-182.6c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-0.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9l132.6 132.7c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3 0.4z'
      }
    ]
  }
})
